import { Button, Card, Col, Divider, Flex, Form, Radio, RadioChangeEvent, Row, Select, Typography } from 'antd';
import { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultOptionType } from 'antd/es/select';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// components
import FormElement from 'components/formElement/formElement';
import FileInput from 'components/fileInput/fileInput';
import ListButton from 'components/listButton/listButton';
import Icon from 'utils/icon';
import CompoundElement from 'components/compoundElement/compoundElement';
import DisabledElement from 'components/disabledElement/disabledElement';
import StatusComponent from 'components/status/status';
import PageTitle from 'components/title/title';
import BackButton from 'components/backButton/backButton';
import ComponentHeader from 'components/componentHeader/componentHeader';

// services

// styles

// models
import { Suspend, SuspendType } from '../models/suspend';
import { onGetSystemSuspendRequestById } from '../services/suspendServices';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import NotificationService from 'core/services/notification';
import { isRTL } from 'core/services/language';
import FilePreview from 'components/filePreview/filePreview';
import { formatFileSize } from 'utils/FileSize';
import { dateFormat } from 'utils/dateFormat';

interface SuspendViewPageProps {}

const SystemSuspendViewPage: FunctionComponent<SuspendViewPageProps> = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();
	const [suspendForm] = Form.useForm();

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [suspend, setsuspend] = useState<Suspend>();

	const suspendTypeOptions = [
		{
			value: 'Founder',
			label: <p className="fw-semibold mb-0">{t('ACTIONS.FOUNDER')}</p>,
		},
		{
			value: 'UnderAge',
			label: <p className="fw-semibold mb-0">{t('ACTIONS.UNDER_AGE')}</p>,
		},
	];

	useEffect(() => {
		getSuspendDetails();
	}, []);

	const getSuspendDetails = async () => {
		try {
			setIsLoading(true);

			const response = await onGetSystemSuspendRequestById(id as string);
			setsuspend(response);

			setIsLoading(false);
		} catch (error) {
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.FETCH_ERROR'));
			navigate('/dashboard/actions/suspend');
		}
	};

	return (
		<>
			<PageTitle name={t('TITLE.ACTIONS')} />

			<BackButton />

			{isLoading ? (
				<LoadingComponent />
			) : (
				<Form form={suspendForm} onFinish={() => {}}>
					<Card>
						<ComponentHeader title={t('ACTIONS.SUSPEND')} />

						<Radio.Group
							className="customRadio"
							disabled
							style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
							options={suspendTypeOptions}
							value={suspend?.type}
						/>

						<Row gutter={[16, 16]} className="mt-5">
							<Col span={24} md={12}>
								<DisabledElement label={t('COMMON.ARABIC_DESC')} value={suspend?.translated_description.ar} />
							</Col>
							<Col span={24} md={12}>
								<DisabledElement label={t('COMMON.ENGLISH_DESC')} value={suspend?.translated_description.en} />
							</Col>
						</Row>
					</Card>
				</Form>
			)}
		</>
	);
};

export default SystemSuspendViewPage;
